import { zfcsr, zfUtils } from "./zf_utils";
import { Swiper, Navigation, A11y } from "./swiper-config";
export class zfcan {
    static hasTargets() {
        return $(".zfcan-anchor-navigation").length > 0;
    }
    static checkAnchorIsInView() {
        if (!(zfcan.anchorSlider.width() > zfcan.anchorSlider.parent().width())) {
            zfcan.anchorSlider.css({ left: 0 });
        }
        if ((zfcan.anchorSlider.length > 1
            ? zfcan.anchorSlider[0].getBoundingClientRect().top
            : 0) +
            42 <
            window.screen.height) {
            zfcan.anchorSlider.addClass("zfcan-anchor-slider-initialized");
        }
    }
    static scrollTo(target) {
        zfcan.anchorSliderParentWidth = zfcan.anchorSlider.parent().width();
        var heightToSubtrak, targetToScroll = $(target.find("a").attr("href"));
        if (!zfcan.anchorNav.closest(".zfch2-header2-wrapper").length &&
            !zfcan.anchorNav.hasClass("zfcan-anchor-sticky") &&
            targetToScroll.offset().top >
                zfcan.anchorNav.height() + zfcan.anchorNav.offset().top) {
            zfcan.appendToHeader();
        }
        heightToSubtrak =
            targetToScroll.offset().top -
                (zfcan.headerWrapper.height() +
                    (zfcan.headerWrapper.css("top") == "auto"
                        ? 0
                        : parseInt(zfcan.headerWrapper.css("top"))));
        if (scrollTo) {
            setTimeout(function () {
                window.scrollTo({
                    top: heightToSubtrak,
                    behavior: "smooth",
                });
            }, 500);
            setTimeout(function () {
                zfcan.setAnchorActive(target);
                zfcan.anchorScroll = false;
                $("a, button").each(function () {
                    if (zfUtils.inViewport($(this))) {
                        $(this).focus();
                        return false;
                    }
                });
            }, 200);
        }
        if (zfcan.anchorSlider.width() < zfcan.anchorSliderParentWidth) {
            return;
        }
    }
    static setAnchorActive(target) {
        var totalLeft = 0;
        zfcan.scrollItems.each(function (a) {
            if (target.index() === a) {
                clearTimeout(zfcan.scrollTimeout);
                zfcan.scrollTimeout = setTimeout(function () {
                    zfcan.anchorItems.removeClass("zfcan-anchor-active");
                    target.parent().addClass("zfcan-anchor-active");
                    if (zfcan.useSwiper) {
                        var targetParent = target.parent().parent().parent();
                        var targetParentID = targetParent.attr("id");
                        var activeTarget = target.parent().index();
                        if (target.parent().offset().left - target.parent().width() <
                            targetParent.offset().left + 20 ||
                            (targetParent.find(".swiper-button-next").length &&
                                target.parent().offset().left + target.parent().width() >
                                    targetParent.find(".swiper-button-next").offset().left)) {
                            $.each(zfcan.anchorNavSliders, function (index, x) {
                                if (targetParentID == x.id) {
                                    x.swiper.slideTo(activeTarget);
                                    x.swiper.update();
                                    return;
                                }
                            });
                        }
                    }
                    else {
                        var targetParent = target.parent().parent().parent().parent();
                        if (target.parent().offset().left - target.parent().width() <
                            targetParent.offset().left + 20 ||
                            (targetParent.find(".slick-next").length &&
                                target.parent().offset().left + target.parent().width() >
                                    targetParent.find(".slick-next").offset().left)) {
                            $(".zfcan-anchor-navigation.zfcan-anchor-sticky .zfcan-anchor-list").slick("slickGoTo", target.parent().data("slick-index"));
                        }
                    }
                }, 100);
                return false;
            }
            totalLeft = totalLeft + Math.round($(this).outerWidth());
        });
    }
    static sumItemsWidth(items) {
        var maxWidth = 0;
        var totalWidth = 0;
        items.each(function () {
            var currWidth = $(this).outerWidth() + 30;
            totalWidth = totalWidth + currWidth;
            if (currWidth > maxWidth)
                maxWidth = currWidth;
        });
        return totalWidth;
    }
    static appendToHeader() {
        zfcan.anchorNav.addClass("zfcan-anchor-sticky");
        zfcan.anchorPlaceHolder.insertAfter(zfcan.anchorNav);
        zfcan.anchorNav.appendTo($(".zfch2-header2 .zfch2-header2-sticky-anchor-holder"));
    }
    static removeFromHeader() {
        zfcan.anchorNav.removeClass("zfcan-anchor-sticky");
        zfcan.anchorNav.detach();
        zfcan.anchorNav.insertAfter(zfcan.anchorPlaceHolder);
        zfcan.anchorPlaceHolder.detach();
    }
    static onScroll(e) {
        zfcan.currentTarget = null;
        var headerTop = zfcan.headerWrapper.css("top");
        var headerHeight = zfcan.headerWrapper.height();
        zfcan.headerOffset = headerHeight - (headerTop === "auto" ? 0 : parseInt(headerTop, 10) * -1);
        const isSticky = zfcan.anchorNav.hasClass("zfcan-anchor-sticky");
        if (!zfcan.anchorScroll) {
            const activeOffset = headerHeight + (isSticky ? zfcan.anchorNav.height() : 0);
            zfcan.anchorTargets.every(function (el) {
                const target = document.getElementById(el.target);
                if (!target) {
                    return false;
                }
                if (target.getBoundingClientRect().top < activeOffset) {
                    zfcan.currentTarget = el.anchor;
                    return true;
                }
                return false;
            });
            if (zfcan.currentTarget) {
                zfcan.setAnchorActive(zfcan.currentTarget);
            }
        }
        const scrollPosition = zfUtils.window.scrollTop() + zfcan.headerOffset;
        if (!isSticky && scrollPosition >= zfcan.stickedAt) {
            zfcan.appendToHeader();
        }
        if (isSticky && scrollPosition < zfcan.stickedAt) {
            zfcan.removeFromHeader();
        }
    }
    static responsiveArr(items, maxSize) {
        var returnArr = [];
        var maxWidth = 0;
        var totalWidth = 0;
        items.each(function () {
            var currWidth = $(this).outerWidth() + 30;
            totalWidth = totalWidth + currWidth;
            if (currWidth > maxWidth)
                maxWidth = currWidth;
        });
        var anchItemLength = items.length;
        while (maxSize > 320) {
            var resolution = maxSize;
            var calcCount = Math.floor((resolution - 100) / maxWidth) > anchItemLength
                ? anchItemLength
                : Math.floor((resolution - 100) / maxWidth);
            if (calcCount == 0)
                calcCount = 1;
            returnArr.push({
                breakpoint: resolution,
                settings: {
                    arrows: true,
                    slidesToShow: calcCount,
                    slidesToScroll: calcCount,
                    dots: false,
                },
            });
            maxSize = maxSize - 75;
        }
        return returnArr;
    }
    static checkAnchorNavIncluded(array, key, value) {
        let exists = false;
        $.each(array, function (index, obj) {
            if (obj.hasOwnProperty(key) && obj[key] === value) {
                exists = true;
                return false;
            }
        });
        return exists;
    }
    static init() {
        try {
            if (!zfcan.hasTargets())
                return;
            if (zfcan.checkInViewScrollKey !== null) {
                zfUtils.offScroll(zfcan.checkInViewScrollKey);
            }
            if (zfcan.anchorScrollKey !== null) {
                zfUtils.offScroll(zfcan.anchorScrollKey);
            }
            zfcan.checkInViewScrollKey = zfUtils.onScroll(zfcan.checkAnchorIsInView);
            zfcan.anchorScrollKey = zfUtils.onScroll(zfcan.onScroll);
            zfcan.anchorTargets = [];
            zfcan.anchorNav = $(".zfcan-anchor-navigation");
            zfcan.anchorPlaceHolder = $(document.createComment("anchor placeholder"));
            zfcan.anchorSlider = $(".zfcan-anchor-slider");
            zfcan.headerWrapper = $(".zfch2-header2");
            zfcan.htmlBody = $("html, body");
            zfcan.scrollItems = $(".zfcan-anchor-list").children();
            zfcan.scrollContent = $(".zfcan-anchor-list .slick-track");
            zfcan.stickedAt = zfcan.anchorNav.offset().top;
            var sliderList = [];
            $(".zfcan-anchor-navigation").each(function () {
                var anchor = $(this);
                var anchorID = $(this).attr("id");
                zfcan.useSwiper = anchor.find(".zfcan-anchor-list").hasClass("swiper");
                zfcan.checkAnchorIsInView();
                zfcan.anchorItems = anchor.find(".zfcan-anchor-item");
                var totalWidth = 0;
                anchor
                    .find(".zfcan-anchor-item")
                    .find("a")
                    .each(function () {
                    if ($(this.parentNode).length > 0 &&
                        $(this).attr("href").length > 0)
                        zfcan.anchorTargets.push({
                            anchor: $(this),
                            target: $(this).data("target"),
                        });
                    $(this)
                        .off("click.zfcan")
                        .on("click.zfcan", function (e) {
                        e.preventDefault();
                        window.history.replaceState(null, "", $(this).attr("href"));
                        zfcsr.scrollToURLAnchorNav(e);
                        if (this.closest(".zfcan-anchor-navigation").classList.contains("zfcan-active") &&
                            zfcan.useSwiper == false) {
                            zfcan.scrollTo($(this));
                        }
                    });
                });
                var responsiveArr = zfcan.responsiveArr(anchor.find(".zfcan-anchor-item"), 1136);
                if (zfcan.useSwiper) {
                    $(".zfcan-anchor-list:not(.swiper-initialized)").each(function () {
                        var anchorItemCount = $(this).find(".zfcan-anchor-item").length;
                        const swiper = new Swiper("#" + $(this).attr("id"), {
                            modules: [Navigation, A11y],
                            allowTouchMove: true,
                            slidesPerView: "auto",
                            spaceBetween: 0,
                            loop: false,
                            normalizeSlideIndex: true,
                            preventClicks: false,
                            preventClicksPropagation: false,
                            navigation: {
                                enabled: anchorItemCount > 1,
                                nextEl: "swiper-button-next",
                                prevEl: "swiper-button-prev",
                            },
                            a11y: {
                                enabled: true,
                                nextSlideMessage: "Next slide",
                                prevSlideMessage: "Previous slide",
                                paginationBulletMessage: "Jump to slide {{index}}",
                                slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                                slideRole: "group",
                                itemRoleDescriptionMessage: "slide",
                            },
                        });
                        if (zfcan.checkAnchorNavIncluded(zfcan.anchorNavSliders, "id", $(this).attr("id")) == false) {
                            zfcan.anchorNavSliders.push({
                                id: $(this).attr("id"),
                                swiper: swiper,
                            });
                        }
                    });
                    anchor
                        .find(".swiper-wrapper")
                        .css("width", zfcan.sumItemsWidth(anchor.find(".zfcan-anchor-item")));
                }
                else {
                    $(".zfcan-anchor-list")
                        .slick({
                        rows: 0,
                        dotsClass: "custom-dots",
                        dots: responsiveArr[0]["settings"]["dots"],
                        swipeToSlide: false,
                        swipe: true,
                        infinite: false,
                        arrows: true,
                        slidesToShow: responsiveArr[0]["settings"]["slidesToShow"],
                        slidesToScroll: responsiveArr[0]["settings"]["slidesToScroll"],
                        responsive: responsiveArr,
                        variableWidth: true,
                    })
                        .show();
                    anchor
                        .find(".slick-track")
                        .css("width", zfcan.sumItemsWidth(anchor.find(".zfcan-anchor-item")));
                }
                zfcan.anchorNav.addClass("zfcan-active");
            });
        }
        catch (err) {
            console.log("Initalization failed: zfcan.init() " + err.message);
        }
    }
}
zfcan.anchorNavSliders = [];
zfcan.headerWrapper = $(".zfch2-header2");
zfcan.headerOffset = 0;
zfcan.headerTop = 0;
zfcan.stickedAt = 0;
zfcan.anchorScroll = false;
zfcan.anchorSliderParentWidth = 0;
zfcan.anchorSliderWidth = 0;
zfcan.currentPos = 0;
zfcan.currentMove = 0;
zfcan.startPos = false;
zfcan.anchorItems = [];
zfcan.currentTarget = null;
zfcan.anchorTargets = [];
zfcan.scrollTimeout = null;
zfcan.checkInViewScrollKey = null;
zfcan.anchorScrollKey = null;
try {
    zfUtils.onReady(function () {
        zfcan.init();
    });
}
catch (err) {
    console.log("Initalization failed: zfcan.init() " + err.message);
}
